import { Bar, BarChart, CartesianGrid, LabelList, Tooltip, XAxis, YAxis } from "recharts";
import { formatCompactCurrency, formatCurrency } from "@/lib/calculators";
import { NEW_MRR } from "./exampleData";
import {
  BORDER,
  CHART_POSITIVE,
  MUTED_FG,
  tooltipStyle,
  xAxisProps,
  yAxisProps,
} from "./chartTheme";
import MetricChartFrame from "./MetricChartFrame";

/**
 * New MRR by month — the recurring revenue added by first-time customers. A gain
 * (the app's positive green), trending up to the running example's $4,000 month.
 */
const NewMrrChart = () => (
  <MetricChartFrame
    caption="New MRR trends from $2,800 to $4,000 over six months as first-time customers sign up — the clearest read on how well acquisition is working."
    breakdown="No breakdown"
    active="6M"
  >
    <BarChart data={NEW_MRR} margin={{ top: 16, right: 8, left: 8, bottom: 0 }}>
      <CartesianGrid strokeDasharray="3 3" stroke={BORDER} vertical={false} />
      <XAxis dataKey="label" {...xAxisProps} />
      <YAxis tickFormatter={(v) => formatCompactCurrency(Number(v))} width={52} {...yAxisProps} />
      <Tooltip
        cursor={{ fill: "hsl(var(--muted) / 0.4)" }}
        contentStyle={tooltipStyle}
        formatter={(value: number) => [formatCurrency(value), "New MRR"]}
      />
      <Bar dataKey="value" fill={CHART_POSITIVE} radius={[4, 4, 0, 0]} isAnimationActive={false}>
        <LabelList
          dataKey="value"
          position="top"
          formatter={(v: number) => formatCompactCurrency(Number(v))}
          fontSize={11}
          fill={MUTED_FG}
        />
      </Bar>
    </BarChart>
  </MetricChartFrame>
);

export default NewMrrChart;
